var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigmaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_865_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7242 100C41.9517 100 49.4406 92.5337 49.4406 83.3337V66.667H32.7242C23.4968 66.667 16.0078 74.1337 16.0078 83.3337C16.0078 92.5337 23.4968 100 32.7242 100Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0078 49.9997C16.0078 40.7997 23.4968 33.333 32.7242 33.333H49.4406V66.6663H32.7242C23.4968 66.6663 16.0078 59.1997 16.0078 49.9997Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0078 16.6667C16.0078 7.46667 23.4968 0 32.7242 0H49.4406V33.3333H32.7242C23.4968 33.3333 16.0078 25.8667 16.0078 16.6667Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4414 0H66.1578C75.3853 0 82.8742 7.46667 82.8742 16.6667C82.8742 25.8667 75.3853 33.3333 66.1578 33.3333H49.4414V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8742 49.9997C82.8742 59.1997 75.3853 66.6663 66.1578 66.6663C56.9304 66.6663 49.4414 59.1997 49.4414 49.9997C49.4414 40.7997 56.9304 33.333 66.1578 33.333C75.3853 33.333 82.8742 40.7997 82.8742 49.9997Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_865_509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/Figma-logo.e208f48b30d07806e8be03ee798a2c28.svg";
export { ForwardRef as ReactComponent };